import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const RemoveButton = styled.button`
  background-color: #fa9d96;
  color: white;
  padding: 5px 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #fc584c;
  }
`;

const UploadDropzone = ({setFilesToUpload}) => {
    const [files, setFiles] = useState([]);        

    const onDrop = useCallback(acceptedFiles => {
        const allowedUploadFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        setFiles(prevFiles => {
            const newFiles = [...prevFiles, ...acceptedFiles]; 
            const validFiles = newFiles.filter(file => allowedUploadFileTypes.includes(file.type));
            const filesToUpload = validFiles.slice(0, 3);       
            return filesToUpload; 
        });
    }, []);

    useEffect(() => {
        setFilesToUpload(files);
    }, [files, setFilesToUpload]);
    
    const isDropzoneDisabled = files.length >= 3;

    const removeFile = (file) => () => {        
        const newFiles = files.filter(f => f !== file);
        setFiles(newFiles);
        setFilesToUpload(newFiles);           
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        multiple: true,
        minSize: 0, 
        disabled: isDropzoneDisabled,   
        maxFiles: 3,         
        onDrop,    
    }); 
  
    const acceptedFilesItems = files.map(file => (
        <li key={file.path}>
            {file.name} <RemoveButton onClick={removeFile(file)}>Remove</RemoveButton>
        </li>
    ));

    return (       
        <div>                
            <div {...getRootProps()} style={{ border: '2px dashed #cccccc', padding: '30px', textAlign: 'center', cursor: 'pointer', backgroundColor: '#fafafa' }}>
                <input {...getInputProps()} accept="image/jpeg, image/png, application/pdf"/> 
                {isDropzoneDisabled ? (
                    <p>Maximum files selected.</p>
                ) : isDragActive ? (
                    <p>Drop up to 3 files here</p>
                ) : (
                    <p>Drag 'n' drop files here, or click to select files (max 3)</p>
                )}                                   
            </div>
            <ul>{acceptedFilesItems}</ul>      
        </div>        
    );
};

export default UploadDropzone;